export default __webpack_public_path__ + "static/media/big_unicorn.b8a019c4.png";